module.exports = __webpack_public_path__ + "img/welfare-1.efcdb638.png";